import React, { useCallback } from "react";

import { SwitchBoxField, TextField } from "../../../../../../../../../../components/forms/fields";
import { DataSelectorTypesField } from "../../../../../../../../../../components/fields/DataSelectorTypesField";
import { DataSelectorActionsField } from "../../../../../../../../../../components/fields/DataSelectorActionsField";
import { ObjectStructuresField } from "../../../../../../../../../../components/fields/ObjectStructuresField";
import { DestinationObjectPropertyCodeField } from "../../../../../../../../../../components/fields/DestinationObjectPropertyCodeField";
import { FieldGroup } from "../../../../../../../../../../components/forms/FieldGroup/FieldGroup";
import { DataSelectorConditionTypeField } from "../../../../../../../../../../components/fields/DataSelectorConditionTypeField";
import { useSearchParams } from "../../../../../../../../../../hooks/searchParams";
import { availableBlockSelectorActionCodes } from "../../../../../../constants";

import styles from "./styles.module.scss";

const FormFields = ({ formProps }) => {
    const { values, form: { mutators: { push } } } = formProps;
    const { receiver_code } = useSearchParams();

    const handleSort = useCallback(
        (options) => {
            if(options) {
                return options.filter(({ value }) => availableBlockSelectorActionCodes.includes(value));
            }

            return options;
        },
        []
    );

    return (
        <>
            <div className={styles.rootFields}>
                <TextField
                    name="name"
                    label="Name"
                    isRequired
                />

                <DataSelectorTypesField isRequired />

                <DataSelectorActionsField
                    isRequired
                    onSortOption={handleSort}
                />
            </div>

            <div>

                {
                    values.action_code === "STORE_TO_DB" ? (
                        <>
                            <ObjectStructuresField
                                receiverCode={receiver_code}
                                isRequired
                            />

                            <DestinationObjectPropertyCodeField
                                receiverCode={receiver_code}
                                objectStructuresValues={values?.destination_object_code}
                            />
                        </>
                    ) :
                        values.action_code === "STORE_TO_BUFFER" ? (
                            <TextField
                                name="buffer_variable_name"
                                label="Variable Name *"
                                isRequired
                            />
                        ) :
                        values.action_code === "STORE_TO_METADATA" ? (
                            <TextField
                                name="metadata_property_name"
                                label="Metadata Property Name *"
                                isRequired
                            />
                        )
                            : null
                }
            </div>

            <div className={styles.switchBoxes}>
                <SwitchBoxField
                    name="is_multiple"
                    label="Multiple results"
                />

                <SwitchBoxField
                    name="is_required"
                    label="Required"
                />
            </div>

            <FieldGroup
                buttonName="selector"
                nameGroup="selectors"
                label="Selectors"
                fieldsProps={[
                    { nameField: "selector", placeholder: "SelectorsBlock" },
                    { nameField: "sub_selector", placeholder: "Sub selector", isRequired: false }
                ]}
                push={push}
            />

            {
                    values?.selectors?.length >= 2 && (
                    <DataSelectorConditionTypeField/>
                )
            }
        </>
    );
};

export default FormFields;
